import { ModuleWithProviders, NgModule } from '@angular/core';

import { PageTitleBarService } from './page-title-bar.service';

@NgModule()
export class PageTitleBarModule {
  public static forRoot(): ModuleWithProviders<PageTitleBarModule> {
    return {
      ngModule: PageTitleBarModule,
      providers: [
        PageTitleBarService,
      ],
    };
  }
}
